/**
 * Lowercases, trims and collapses internal whitespace.
 *
 * Mirrors `ListItem.Normalise` on the server exactly. It has to: the client uses this to
 * decide "you already have that", and the server uses its copy to build the suggestion
 * chips. If the two disagreed, a chip could offer something the client would then refuse
 * to add, which would look like the app simply ignoring a tap.
 */
export function normaliseItemName(name: string): string {
  return name.split(' ').filter(Boolean).join(' ').toLowerCase();
}
